var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1471 320L1471 348",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1471.5,
    cy: 315.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.99 315.19C1466.99 311.283 1470.29 308.117 1474.36 308.117C1474.94 308.117 1475.51 308.184 1476.06 308.308C1474.74 307.48 1473.19 307 1471.52 307C1466.81 307 1463 310.806 1463 315.5C1463 320.194 1466.81 324 1471.52 324C1473.81 324 1475.89 323.093 1477.43 321.62C1476.49 322.032 1475.45 322.263 1474.36 322.263C1470.29 322.263 1466.99 319.096 1466.99 315.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.4 314.6L1480.37 312.146L1478.54 313.719L1476.3 313.056L1477.11 315.337L1475.77 317.381L1478.1 317.218L1479.5 319.144L1480.13 316.763L1482.34 315.909L1480.4 314.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch8);
export default __webpack_public_path__ + "static/media/church_8.fc87250f8da27fbf63c7144e9985d317.svg";
export { ForwardRef as ReactComponent };